import api from '../axiosInstance';
import { AUTH_ENDPOINTS } from '../constants';

export const loginUser = (username, passcode) => {
  let data = {
    "oauthUserCred" : passcode,
    "email" : username
  }
  return api.post(AUTH_ENDPOINTS.LOGIN, data);
}

export const changePasscode = (userId, role, passcode) => {
  let data = {
    "userId" : userId,
    "role" : role,
    "passcode" : passcode
  }
  return api.post(AUTH_ENDPOINTS.CHANGE_PASSCODE, data);
}

export const refreshToken = () => api.post(AUTH_ENDPOINTS.REFRESH); 